<template>
  <div class="reacord-container">
    <div class="g-flex-end" style="margin-bottom: 20px">
      <el-button @click="$router.push({ path: '/gasStationManage/openTime' })">返回上一页</el-button>
    </div>
    <mer-table :loading="tableLoading" 
      :tableConfig="tableConfig" 
      :tableData="tableData" 
      :pagination="pagination" 
      @SizeChange="handleSizeChange" 
      @PageChange="pageChange">
      <template slot="action" slot-scope="{row}">
        <el-button size="mini" v-if="row.auditStatus === 1" type="primary" @click="withdraw(row)">撤销</el-button>
      </template>
    </mer-table>
  </div>
</template>
<script>
import { getOpenTimeRecord, revokeApply } from '@/api/gasStationManage/gasInfo'
import listPage from '@/mixins/listPage'
const tableConfig = [
  { label: '修改来源', prop: 'updateSourceStr', align: 'center' },
  { label: '修改原因', prop: 'editReason', align: 'center' },
  { label: '修改前时间', prop: 'editBefore', align: 'center' },
  { label: '修改后时间', prop: 'editAfter', align: 'center' },
  { label: '当前审核状态', prop: 'auditStatusStr', align: 'center' },
  { label: '审核状态时间', prop: 'auditTime', align: 'center' },
  { label: '操作', prop: 'action', slot: "action", align: 'center' }
]

export default {
  // name: 'openTime_record',
  mixins: [listPage],
  data () {
    return {
      tableConfig
    }
  },
  methods: {
    async withdraw (row) {
      try {
        const { code } = await revokeApply({ applyId: row.id })
        if (code !== 200) return
          this.$message.success('操作成功')
          this.initList(getOpenTimeRecord, false, null, this.$route.query)
      } catch (error) {
        console.log(error)
      }
    }
  },
  created () {
    this.initList(getOpenTimeRecord, false, null, this.$route.query)
  }
}
</script>
<style lang="less" scoped>
  .reacord-container {
    padding-top: 30px;
  }
</style>
